







































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Choices from '@/store/modules/Choices';
import Scoring from '@/store/modules/Scoring';
import FactorGroupScoringDefinition from '@/components/scoring-definition/FactorGroupScoringDefinition.vue';
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import Viewpoints from '@/store/modules/Viewpoints';
import TableChoiceScoringComparison from '@/views/ViewpointChoicesScorer/ViewpointChoicesScorerFixedTable.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ViewpointFactorScore from '@/components/scoring-input/ViewpointFactorScore.vue';
import { NotificationEventBus } from '@/EventBus';
import Decisions from '@/store/modules/Decisions';
import ScoringKeyEditorDialog from '@/components/scoring-key/ScoringKeyEditorDialog.vue';
import Dialogs from '@/store/modules/Dialogs';
import ScoringKeyButtonTrigger from '@/components/scoring-key/ScoringKeyButtonTrigger.vue';
import TableSingleChoiceScoringComparison from '@/views/ViewpointChoicesScorer/ViewpointChoicesScorerGrowingTable.vue';
import Modelling from '@/store/modules/Modelling';
import { ViewpointFactorResource } from '@/api/model/ViewpointFactorResource';
import FactorScoringDefinitionButtonTrigger from '@/components/scoring-definition/FactorScoringDefinitionButtonTrigger.vue';
import ChoiceScoreChart from '@/views/ViewpointChoicesScorer/ChoiceScoreChart.vue';
import ChoiceScoreRadialChart from '@/views/ViewpointChoicesScorer/ChoiceScoreRadialChart.vue';
import ChoiceScoreSummaryChart from '@/views/ViewpointChoicesScorer/ChoiceScoreSummaryChart.vue';
import { property } from 'node_modules/@types/lodash';

const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);
const scoringModule = getModule(Scoring);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);
@Component({
    name: 'ChoiceComparisonScoringGroupComp',
    components: {
        FactorScoringDefinitionButtonTrigger,
        TableSingleChoiceScoringComparison,
        ScoringKeyButtonTrigger,
        ScoringKeyEditorDialog,
        ViewpointFactorScore,
        TableChoiceScoringComparison,
        FactorValueDisplay,
        FactorGroupScoringDefinition,
        ChoiceScoreChart,
        ChoiceScoreRadialChart,
        ChoiceScoreSummaryChart,
    },
})
export default class ChoiceComparisonScoringGroup extends Vue {
    @Ref('factorRow')
    readonly factorRow!: HTMLDivElement[];

    @Prop({ default: 0, type: Number })
    factorLevel!: number;

    @Ref('scorer')
    readonly scorerEle!: HTMLDivElement;

    @Prop()
    elements!: string[];

    @Prop()
    columnWidths!: any;

    @Prop()
    choiceIds!: string[];

    @Prop({ default: false, type: Boolean })
    displayPercentValue!: boolean;

    mounted() {

        
    }

    // description
    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get columnWidth() {
        return workspaceOptionsModule.choiceColumnWidth;
    }

    get choiceFirstCol() {
        return workspaceOptionsModule.choiceFirstCol;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectionPath() {
        return workspaceOptionsModule.selectionPath;
    }

    get expansionValues() {
        return workspaceOptionsModule.expansions;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get activeViewpointId() {
        return viewpointModule.activeViewpointId;
    }

    get scoredChoices() {
        if (this.activeViewpointId) {
            return scoringModule.viewpointScores[this.activeViewpointId];
        }
    }

    get selectedViewpoint() {
        if (viewpointModule.activeViewpointId && viewpointModule.decisionViewpointsMap) {
            return viewpointModule.decisionViewpointsMap[viewpointModule.activeViewpointId];
        }
    }

    get choices() {
        return choicesModule.choices;
    }

    get choiceVisibility() {
        return workspaceOptionsModule.choiceVisibility;
    }

    get activeViewpointContributingFactorResources() {
        return viewpointModule.activeViewpointContributingFactorResources;
    }

    get viewpointFactorResources() {
        if (this.selectedViewpoint) {
            return (
                viewpointModule.viewpointFactorResources[this.selectedViewpoint.viewpointId] || {}
            );
        }
        return {};
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get factorListTree() {
        return modellingModule.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    get showFactorData() {
        return workspaceOptionsModule.showFactorData;
    }

    private disableFixedTable( resourceId: string ) {
        return this.factors[resourceId].groupTypeDefinition && this.factors[resourceId].groupTypeDefinition.type === 'TABLE_FIXED' && !this.showFactorData;
    }

    private startingFactors(resourceId: string) {
        if (workspaceOptionsModule.trimTopGroups) {
            let topFactor = resourceId;
            return this.getTopGroup(resourceId);
        } else {
            return this.factors[resourceId].childrenIds;
        }
    }

    private getTopGroup(topId: string) {
        if (
            this.factors[topId].childrenIds.length != 1
                ? true
                : 'groupTypeDefinition' in this.factors[this.factors[topId].childrenIds[0]] || this.factors[this.factors[topId].childrenIds[0]].type != 'FACTOR_GROUP'
        ) {
            return this.factors[topId].childrenIds;
        }

        if (this.factors[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factors[topId].childrenIds[0]);
        }
    }
    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get selectedBreadcrumb() {
        return workspaceOptionsModule.selectedPathItemId
    }

    private showDataToolTip(value: any) {
        if (value && !this.showFactorData) {
            return true;
        }
        return false;
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return  this.contributingVisibility || (!this.contributingVisibility && this.activeViewpointContributingFactorResources[resourceId])
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

    // description
    private getDescriptionVisibility() {
        return this.descriptionVisibility;
    }

    private selectScoringDefinitionEdit(viewpointId: string, factorId: string) {
        getModule(Dialogs).editScoringDefinition({
            viewpointId: viewpointId,
            resourceId: factorId,
        });
    }

    private factorGroupScoringDefinitionChange(factorGroupId: string, scoringDefinition: any) {
        if (!this.selectedViewpoint) return;

        let viewpointFactor: ViewpointFactorResource;
        if (this.viewpointFactorResources && this.viewpointFactorResources[factorGroupId]) {
            viewpointFactor = this.viewpointFactorResources[factorGroupId];
            viewpointFactor.summaryScoringFunction = scoringDefinition.summaryScoringFunction;
        } else {
            viewpointFactor = {
                id: factorGroupId,
                //    scoringKeyDefinition: scoringDefinition,
                viewpointId: this.selectedViewpoint.viewpointId,
                summaryScoringFunction: scoringDefinition.summaryScoringFunction,
            };
        }

        NotificationEventBus.emitProcessingMessage();
        viewpointModule
            .putViewpointFactor(viewpointFactor)
            .then((result) => NotificationEventBus.emitSuccessMessage())
            .catch((err) => NotificationEventBus.emitFailedMessage(err));
    }
}
